import { Check, PauseCircle, CalendarDays } from "lucide-react";
import { ESTADO_PASOS } from "./portalApi";
import { fechaCorta } from "@/components/contratos/constants";

export const EstadoObra = ({ obra, cliente }) => {
  const actual = ESTADO_PASOS.findIndex(([k]) => k === obra.estado.clave);
  return (
    <section className="rounded-3xl bg-white border border-slate-200 shadow-sm overflow-hidden" data-testid="portal-obra">
      <div className="px-5 sm:px-8 pt-6 pb-5">
        {cliente && <p className="text-sm text-slate-500">Hola, {cliente}</p>}
        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#1B2B4B] mt-1 break-words" data-testid="portal-obra-nombre">{obra.nombre}</h1>
        {obra.descripcion && <p className="text-sm sm:text-base text-slate-600 mt-2 whitespace-pre-line max-w-3xl" data-testid="portal-obra-descripcion">{obra.descripcion}</p>}
        {(obra.fecha_inicio || obra.fecha_fin_prevista) && (
          <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-slate-500"><CalendarDays className="w-4 h-4 text-[#00B4CC]" />
            {obra.fecha_inicio && `Inicio ${fechaCorta(obra.fecha_inicio)}`}{obra.fecha_inicio && obra.fecha_fin_prevista && " · "}{obra.fecha_fin_prevista && `Fin previsto ${fechaCorta(obra.fecha_fin_prevista)}`}</p>
        )}
      </div>
      <div className="bg-[#1B2B4B] px-5 sm:px-8 py-4">
        <ol className="flex items-center" data-testid="portal-estado-obra" data-estado={obra.estado.clave}>
          {ESTADO_PASOS.map(([k, l], i) => (
            <li key={k} className={`flex items-center ${i < ESTADO_PASOS.length - 1 ? "flex-1" : ""}`}>
              <span className={`flex items-center gap-2 text-xs sm:text-sm font-semibold ${i <= actual ? "text-white" : "text-white/40"}`}>
                <span className={`w-7 h-7 rounded-full flex items-center justify-center border-2 ${i < actual ? "bg-[#00B4CC] border-[#00B4CC]" : i === actual ? "border-[#00B4CC] text-[#00B4CC]" : "border-white/25"}`}>
                  {i < actual ? <Check className="w-4 h-4 text-[#1B2B4B]" /> : <span className="text-xs">{i + 1}</span>}
                </span>{l}
              </span>
              {i < ESTADO_PASOS.length - 1 && <span className={`flex-1 h-0.5 mx-2 sm:mx-4 rounded ${i < actual ? "bg-[#00B4CC]" : "bg-white/20"}`} />}
            </li>
          ))}
        </ol>
        {obra.estado.pausa && <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-amber-300" data-testid="portal-obra-pausa"><PauseCircle className="w-4 h-4" /> La obra está en pausa temporalmente.</p>}
      </div>
    </section>
  );
};
